"use strict";

import Vue from 'vue';
import axios from "axios";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
const token = localStorage.accessToken;
if(token) {
  axios.defaults.headers.common['Authorization'] = localStorage.accessToken;
}
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    config.headers.Authorization = localStorage.accessToken;

    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    if(response.data.token) {
      localStorage.accessToken = response.data.token;
      axios.defaults.headers.common.Authorization = localStorage.accessToken;

      // console.log(response.data.token)
    }

    return Promise.resolve(response);
  },
  function(error) {
    // Do something with response error
    console.log(error)
    if(error.response.status === 401) {
      location.href = '/';
      delete localStorage.accessToken
    }
    
    else if(error.response.status === 500) {
      alert(error + "\n문의 바랍니다. 1566-4640")
    }
    
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
